import { render, staticRenderFns } from "./Textblock.vue?vue&type=template&id=725699d8"
import script from "./Textblock.vue?vue&type=script&lang=js"
export * from "./Textblock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports